/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

//urlがalbase_productの場合のみ、headerにクラス付与
  $(function ($) {
    
  if(document.URL.match('revealatelotion-lp')) {
    // URLにmodelhouseが含まれる時に実行する処理を記述する
    $('header').addClass("lp_hidden");
  }
  });

  $(function ($) {
    
  if(document.URL.match('revealatelotion-lp')) {
    // URLにmodelhouseが含まれる時に実行する処理を記述する
    $('body').addClass("lp_back");
  }
  });
  
  $(function ($) {
    
  if(document.URL.match('revealatelotion-lp')) {
    // URLにmodelhouseが含まれる時に実行する処理を記述する
    $('main').addClass("lp_back");
  }
  });
  
  $(function ($) {
    
  if(document.URL.match('revealatelotion-lp')) {
    // URLにmodelhouseが含まれる時に実行する処理を記述する
    $('html').addClass("lp_back");
  }
  });

  $(function ($) {
    
  if(document.URL.match('revealatelotion-lp')) {
    // URLにmodelhouseが含まれる時に実行する処理を記述する
    $('footer').addClass("lp_index");
  }
  });
  
//ローディング画面
  $(window).on('load',function(){
      $("#splash").delay(1500).fadeOut('slow');//ローディング画面を1.5秒（1500ms）待機してからフェードアウト
      $("#splash_logo").delay(1200).fadeOut('slow');//ロゴを1.2秒（1200ms）待機してからフェードアウト
  });

//フェードイン
  $(function ($) {
    var fadeIn = $('.fade-in');
    $(window).scroll(function () {
      $(fadeIn).each(function () {
        var offset = $(this).offset().top;
        var scroll = $(window).scrollTop(); 
        var windowHeight = $(window).height();
        if (scroll > offset - windowHeight + 150) {
          $(this).addClass("scroll-in");
        }
      });
    });
  });

//スムーススクロール
$(function($){
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
　　 var speed = 500;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
});

//ボタンアニメーション
$(function ($) {
    setTimeout('rect()'); //アニメーションを実行
});
 
function rect() {
    $(".lp_highlight").animate({
        opacity: "0"
    }, 1500).animate({
        opacity: "1"
    }, 1500);
    setTimeout("rect()", 3000); //アニメーションを繰り返す間隔
}




// 紹介クーポンページを表示
$(function(){
    if(document.referrer.indexOf('bid')  > -1){
      window.location.href = 'https://www.albase.skin/pages/referral-program';
    }
});







